import React from 'react';

// THE PREP SHIELD LOGO
export const LogoOption1 = ({ className = "w-24 h-24" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="shieldGrad" x1="0" y1="0" x2="100" y2="100">
        <stop offset="0%" stopColor="#3B82F6" /> {/* blue-500 */}
        <stop offset="100%" stopColor="#1D4ED8" /> {/* blue-700 */}
      </linearGradient>
      <filter id="shadow1" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="4" stdDeviation="4" floodOpacity="0.3"/>
      </filter>
    </defs>
    
    {/* Shield Body */}
    <path 
      d="M50 92C50 92 85 78 85 42V20L50 8L15 20V42C15 78 50 92 50 92Z" 
      fill="url(#shieldGrad)" 
      stroke="white" 
      strokeWidth="3"
      filter="url(#shadow1)"
    />
    
    {/* Medical Cross (Negative Space) */}
    <path 
      d="M50 32V68M32 50H68" 
      stroke="white" 
      strokeWidth="8" 
      strokeLinecap="round"
    />
    
    {/* Success Badge */}
    <circle cx="72" cy="72" r="16" fill="white" />
    <circle cx="72" cy="72" r="13" fill="#10B981" /> {/* green-500 */}
    <path d="M66 72L70 76L78 66" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);